import React from 'react';
import { TONE } from '../../components/ui/tokens';
import { costSourceLabel, costSourceTone } from './costSourceLabels';

/** D172.1: the coloured text tag for where a line's cost came from; one component so the grid and drawer agree. Staff only. */
export function CostSourceTag({ item }: { item: Parameters<typeof costSourceLabel>[0] }) {
  const t = costSourceTone(item);
  if (!t) return null;
  return (
    <span title={costSourceLabel(item) ?? undefined} className={`shrink-0 rounded border px-1 text-xs font-medium ${TONE[t.tone]}`}>
      {t.tag}
    </span>
  );
}
